// Exports only metadata already displayed to the current catalogue reader.
// A catalogue entry is not an approved passage or a verified bibliographic citation.
export const exportCopy = {
  tr: ['Katalog kaydını indir (RIS)', 'Katalog kaydını indir (JSON)'],
  en: ['Download catalogue record (RIS)', 'Download catalogue record (JSON)'],
  ar: ['تنزيل سجل الفهرس (RIS)', 'تنزيل سجل الفهرس (JSON)'],
  de: ['Katalogeintrag herunterladen (RIS)', 'Katalogeintrag herunterladen (JSON)'],
  fr: ['Télécharger la notice (RIS)', 'Télécharger la notice (JSON)'],
  ru: ['Скачать запись каталога (RIS)', 'Скачать запись каталога (JSON)'],
  fa: ['دریافت رکورد فهرست (RIS)', 'دریافت رکورد فهرست (JSON)'],
  ur: ['کیٹلاگ ریکارڈ ڈاؤن لوڈ کریں (RIS)', 'کیٹلاگ ریکارڈ ڈاؤن لوڈ کریں (JSON)'],
};

const line = value => String(value ?? '').normalize('NFC').replace(/[\r\n\u0000-\u001f\u007f\u2028\u2029]+/g, ' ').trim();
export function catalogueRecord(item, displayTitle) {
  if (!item || !/^[a-zA-Z0-9:_-]{8,100}$/.test(item.source_id) ||
      !['book', 'video'].includes(item.source_type) || typeof item.title !== 'string' ||
      !line(item.title) || !Number.isInteger(item.processed_units) || item.processed_units < 0 ||
      (item.total_units != null && (!Number.isInteger(item.total_units) || item.total_units < 0))) {
    throw new Error('Invalid catalogue record');
  }
  return {
    format: 'sayyadi.catalogue-record.v1',
    source_id: item.source_id,
    source_type: item.source_type,
    display_title: line(displayTitle) || line(item.title),
    original_title: line(item.title),
    processed_units: item.processed_units,
    total_units: item.total_units ?? null,
    evidence_approved: false,
    note: 'Katalog kaydı; metin doğruluğu, müellif ve baskı doğrulaması değildir. Catalogue metadata only; text, authorship and edition are not certified.',
  };
}

export function catalogueExport(item, title, format) {
  const record = catalogueRecord(item, title);
  if (!['ris', 'json'].includes(format)) throw new Error('Unsupported catalogue export');
  const text = format === 'json' ? JSON.stringify(record, null, 2) + '\n' :
    ['TY  - GEN', `TI  - ${record.display_title}`, `ID  - ${record.source_id}`,
     `N1  - ${record.note}`, `N1  - Original catalogue title: ${record.original_title}`,
     'ER  -', ''].join('\r\n');
  return {text, mime: format === 'ris' ? 'application/x-research-info-systems;charset=utf-8' : 'application/json;charset=utf-8',
    filename: `sayyadi-${record.source_id.replace(/[^a-zA-Z0-9_-]/g, '_')}.${format}`};
}

export function downloadCatalogueRecord(item, title, format) {
  const output = catalogueExport(item, title, format);
  const url = URL.createObjectURL(new Blob([output.text], {type: output.mime}));
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = output.filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
